var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area talent-profile",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          { staticClass: "page-header-top-container" },
          [
            _c(
              "div",
              { staticClass: "page-name mb-2", attrs: { id: "benefitHeader" } },
              [_vm._v(_vm._s(_vm.pageTitle))]
            ),
            _vm._v(" "),
            _vm.isShow
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "back_button btn btn-primary pull-right",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.buttonBack()
                        }
                      }
                    },
                    [_vm._v("\n              Back")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary pull-right",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.print()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-print",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "pull-right",
                    class: { disableclick: _vm.formPrintHide.userType },
                    attrs: {
                      name: "type",
                      id: "type",
                      label: "text",
                      clearable: false,
                      filterable: false,
                      searchable: false,
                      options: _vm.typeOfUser,
                      placeholder: "Select Employee Type"
                    },
                    on: {
                      input: function($event) {
                        return _vm.selectType(_vm.userType)
                      }
                    },
                    model: {
                      value: _vm.userType,
                      callback: function($$v) {
                        _vm.userType = $$v
                      },
                      expression: "userType"
                    }
                  })
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "admin-page-content",
            attrs: { id: "pageContentDiv" }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: { id: "viewDetail", role: "dialog" }
              },
              [
                _c("div", { staticClass: "modal-dialog" }, [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c(
                        "h4",
                        {
                          staticClass: "modal-title",
                          attrs: { id: "defaultModalLabel" }
                        },
                        [_vm._v(" " + _vm._s(_vm.viewTitle) + " ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _vm._v(
                            "\n                                  " +
                              _vm._s(_vm.viewDetail) +
                              "\n                              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary float-right",
                            attrs: { "data-dismiss": "modal", type: "submit" }
                          },
                          [_vm._v("Close")]
                        )
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("form", { attrs: { id: "talentProfile" } }, [
              _c("div", { staticClass: "forms-container" }, [
                _c("div", { staticClass: "form-row mb-20" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-3 thumbnail" },
                    [
                      _vm.is_registered
                        ? [
                            _vm.isEditProfile
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "edit-btn-vvg waves-effect float-r",
                                    attrs: {
                                      title: "Edit User",
                                      to: {
                                        name: "AddUpdateUsers",
                                        params: { id: _vm.userDetail.id },
                                        query: { from: "9box", year: _vm.year }
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-pencil",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.is_registered
                        ? [
                            _vm.isEditProfile
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "edit-btn-vvg waves-effect float-r",
                                    attrs: {
                                      title: "Edit User",
                                      to: {
                                        name: "UpdateNotRegisteredUser",
                                        params: { id: _vm.userDetail.id },
                                        query: { from: "9box", year: _vm.year }
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-pencil",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("img", { attrs: { src: _vm.userImg } })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-9" }, [
                    _c("div", { staticClass: "profile-section" }, [
                      _c("div", { staticClass: "header-block" }, [
                        _vm._v("Profile")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-form-label" },
                          [_vm._v("Current Title :")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-9" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentTitle,
                                expression: "currentTitle"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              disableclick: _vm.formPrintHide.currentTitle
                            },
                            attrs: {
                              type: "text",
                              id: "currentTitle",
                              placeholder: "Enter Current Title"
                            },
                            domProps: { value: _vm.currentTitle },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.currentTitle = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-form-label" },
                          [_vm._v("Current Location :")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-9" },
                          [
                            _c("v-select", {
                              class: {
                                disableclick: _vm.formPrintHide.currentLocation
                              },
                              attrs: {
                                name: "location",
                                id: "location",
                                label: "text",
                                clearable: false,
                                filterable: false,
                                options: _vm.locationArr,
                                placeholder: "Select Location"
                              },
                              model: {
                                value: _vm.location,
                                callback: function($$v) {
                                  _vm.location = $$v
                                },
                                expression: "location"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-form-label" },
                          [_vm._v("Time in Role :")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-9" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.time_role,
                                expression: "time_role"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              disableclick: _vm.formPrintHide.timeInRole
                            },
                            attrs: {
                              type: "text",
                              id: "time_role",
                              placeholder: "Enter Time in Role",
                              autocomplete: "off"
                            },
                            domProps: { value: _vm.time_role },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.time_role = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-form-label" },
                          [_vm._v("Date of Birth :")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-sm-9",
                            class: {
                              disableclick: _vm.formPrintHide.dateOfBirth
                            }
                          },
                          [
                            _c("date-picker", {
                              staticClass: "form-control",
                              attrs: {
                                id: "dateofBith",
                                config: _vm.configCalendar,
                                placeholder: "Enter Date of Birth",
                                name: "dateofBith"
                              },
                              model: {
                                value: _vm.dateofBith,
                                callback: function($$v) {
                                  _vm.dateofBith = $$v
                                },
                                expression: "dateofBith"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mobility-section" }, [
                      _c("div", { staticClass: "header-block" }, [
                        _vm._v("Mobility")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-form-label" },
                          [_vm._v("Now :")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-9" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentMobility,
                                expression: "currentMobility"
                              }
                            ],
                            staticClass: "form-control",
                            class: { disableclick: _vm.formPrintHide.mob_now },
                            attrs: {
                              type: "text",
                              id: "currentMobility",
                              placeholder: "Enter Current Mobility"
                            },
                            domProps: { value: _vm.currentMobility },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.currentMobility = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "label",
                          { staticClass: "col-sm-3 col-form-label" },
                          [_vm._v("2+ Years :")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-9" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.futureMobility,
                                expression: "futureMobility"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              disableclick: _vm.formPrintHide.mob_years
                            },
                            attrs: {
                              type: "text",
                              id: "futureMobility",
                              placeholder: "Enter Mobility 2+ Years"
                            },
                            domProps: { value: _vm.futureMobility },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.futureMobility = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row mb-20" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "accomplishment-section" }, [
                      _c("div", { staticClass: "header-block" }, [
                        _vm._v("Highlights of Current Accomplishments")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentAccomplishment,
                                expression: "currentAccomplishment"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "currentAccomplishment",
                              placeholder:
                                "Enter Highlights of Current Accomplishment"
                            },
                            domProps: { value: _vm.currentAccomplishment },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.currentAccomplishment = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "form-control",
                            attrs: { id: "print_helper" }
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row mb-20" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "strengths-section" }, [
                      _c("div", { staticClass: "header-block" }, [
                        _vm._v("Key Strengths")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-12" },
                          [
                            _c("multiselect", {
                              staticClass: "print-none",
                              attrs: {
                                name: "keyStrengths",
                                id: "keyStrengths",
                                label: "title",
                                options: _vm.listKeyStrengths,
                                multiple: false,
                                "track-by": "id",
                                taggable: false,
                                hideSelected: true,
                                placeholder: "Select Key Strengths"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.addKeyStrengths(_vm.keyStrengths)
                                }
                              },
                              model: {
                                value: _vm.keyStrengths,
                                callback: function($$v) {
                                  _vm.keyStrengths = $$v
                                },
                                expression: "keyStrengths"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "list-user pt-2 pr-2 pl-4" },
                              _vm._l(_vm.selectedkeyStrengths, function(
                                obj,
                                index
                              ) {
                                return _c(
                                  "li",
                                  { staticStyle: { "list-style": "decimal" } },
                                  [
                                    _c("span", [_vm._v(_vm._s(obj.title))]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "info-circle print-none" },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-info-circle",
                                          attrs: {
                                            "data-toggle": "modal",
                                            "data-target": "#viewDetail"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.viewDetailFunc(obj)
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pull-right print-none",
                                        staticStyle: { cursor: "pointer" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-times ml-5",
                                          attrs: { "aria-hidden": "true" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.removeStrengths(obj)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "futureroles-section" }, [
                      _c("div", { staticClass: "row no-gutters" }, [
                        _c("div", { staticClass: "col-sm-6" }, [
                          _c("div", { staticClass: "header-block" }, [
                            _vm._v("Future Roles")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group row no-gutters pr-1" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-12 form-group",
                                  class: {
                                    disableclick: _vm.formPrintHide.futureRole1
                                  },
                                  attrs: { id: "futureRole1div" }
                                },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      attrs: {
                                        name: "cateListActivity",
                                        id: _vm.futureRole1,
                                        label: "role",
                                        options: _vm.futureRolesArr,
                                        multiple: false,
                                        "track-by": "role",
                                        taggable: true,
                                        hideSelected: false,
                                        placeholder: "Enter Role"
                                      },
                                      on: {
                                        tag: _vm.futureRoleOne,
                                        input: _vm.onChange
                                      },
                                      model: {
                                        value: _vm.futureRole1,
                                        callback: function($$v) {
                                          _vm.futureRole1 = $$v
                                        },
                                        expression: "futureRole1"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "caret" }, [
                                        _c("div", [
                                          _c("div", {
                                            staticClass: "multiselect__select",
                                            staticStyle: { display: "none" }
                                          })
                                        ])
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-12 form-group",
                                  class: {
                                    disableclick: _vm.formPrintHide.futureRole2
                                  },
                                  attrs: { id: "futureRole2div" }
                                },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      attrs: {
                                        name: "cateListActivity",
                                        id: _vm.futureRole2,
                                        label: "role",
                                        options: _vm.futureRolesArr,
                                        multiple: false,
                                        "track-by": "role",
                                        taggable: true,
                                        hideSelected: false,
                                        placeholder: "Enter Role"
                                      },
                                      on: {
                                        tag: _vm.futureRoletwo,
                                        input: _vm.onChange
                                      },
                                      model: {
                                        value: _vm.futureRole2,
                                        callback: function($$v) {
                                          _vm.futureRole2 = $$v
                                        },
                                        expression: "futureRole2"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "caret" }, [
                                        _c("div", [
                                          _c("div", {
                                            staticClass: "multiselect__select",
                                            staticStyle: { display: "none" }
                                          })
                                        ])
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-12 form-group",
                                  class: {
                                    disableclick: _vm.formPrintHide.futureRole3
                                  },
                                  attrs: { id: "futureRole3div" }
                                },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      attrs: {
                                        name: "cateListActivity",
                                        id: _vm.futureRole3,
                                        label: "role",
                                        options: _vm.futureRolesArr,
                                        multiple: false,
                                        "track-by": "role",
                                        taggable: true,
                                        hideSelected: true,
                                        placeholder: "Enter Role"
                                      },
                                      on: {
                                        tag: _vm.futureRolethree,
                                        input: _vm.onChange
                                      },
                                      model: {
                                        value: _vm.futureRole3,
                                        callback: function($$v) {
                                          _vm.futureRole3 = $$v
                                        },
                                        expression: "futureRole3"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "caret" }, [
                                        _c("div", [
                                          _c("div", {
                                            staticClass: "multiselect__select",
                                            staticStyle: { display: "none" }
                                          })
                                        ])
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6" }, [
                          _c("div", { staticClass: "header-block" }, [
                            _vm._v("Timing")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group row no-gutters pl-1" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-sm-12 form-group" },
                                [
                                  _c("v-select", {
                                    class: {
                                      disableclick: _vm.formPrintHide.timing1
                                    },
                                    attrs: {
                                      name: "sele_emp",
                                      id: "sele_emp",
                                      label: "text",
                                      filterable: false,
                                      clearable: false,
                                      options: _vm.timingArr,
                                      placeholder: "Select Timing"
                                    },
                                    model: {
                                      value: _vm.timing1,
                                      callback: function($$v) {
                                        _vm.timing1 = $$v
                                      },
                                      expression: "timing1"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-12 form-group" },
                                [
                                  _c("v-select", {
                                    class: {
                                      disableclick: _vm.formPrintHide.timing2
                                    },
                                    attrs: {
                                      name: "sele_emp",
                                      id: "sele_emp",
                                      label: "text",
                                      clearable: false,
                                      filterable: false,
                                      options: _vm.timingArr,
                                      placeholder: "Select Timing"
                                    },
                                    model: {
                                      value: _vm.timing2,
                                      callback: function($$v) {
                                        _vm.timing2 = $$v
                                      },
                                      expression: "timing2"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-12" },
                                [
                                  _c("v-select", {
                                    class: {
                                      disableclick: _vm.formPrintHide.timing3
                                    },
                                    attrs: {
                                      name: "sele_emp",
                                      id: "sele_emp",
                                      label: "text",
                                      clearable: false,
                                      filterable: false,
                                      options: _vm.timingArr,
                                      placeholder: "Select Timing"
                                    },
                                    model: {
                                      value: _vm.timing3,
                                      callback: function($$v) {
                                        _vm.timing3 = $$v
                                      },
                                      expression: "timing3"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row mb-20" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "development-section" }, [
                      _c("div", { staticClass: "header-block" }, [
                        _vm._v("Development Opportunities")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-12" },
                          [
                            _c("multiselect", {
                              staticClass: "print-none",
                              attrs: {
                                name: "opportunities",
                                id: "opportunities",
                                label: "title",
                                options: _vm.listKeyStrengths,
                                multiple: false,
                                "track-by": "id",
                                taggable: false,
                                hideSelected: true,
                                placeholder: "Select Development Opportunities"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.addOpportunities(_vm.opportunities)
                                }
                              },
                              model: {
                                value: _vm.opportunities,
                                callback: function($$v) {
                                  _vm.opportunities = $$v
                                },
                                expression: "opportunities"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "list-user pt-2 pr-2 pl-4" },
                              _vm._l(_vm.selectedOpportunities, function(
                                obj,
                                index
                              ) {
                                return _c(
                                  "li",
                                  { staticStyle: { "list-style": "decimal" } },
                                  [
                                    _c("span", [_vm._v(_vm._s(obj.title))]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "info-circle print-none" },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-info-circle",
                                          attrs: {
                                            "data-toggle": "modal",
                                            "data-target": "#viewDetail"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.viewDetailFunc(obj)
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pull-right print-none",
                                        staticStyle: { cursor: "pointer" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-times ml-5",
                                          attrs: { "aria-hidden": "true" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.removeOpportunities(
                                                obj
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row mb-20" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "development-section" }, [
                      _c("div", { staticClass: "header-block" }, [
                        _vm._v("Education / Certificates")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row no-gutters" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-12" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary float-right mt-2 ml-2",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.addCertificate()
                                  }
                                }
                              },
                              [_vm._v("+")]
                            ),
                            _vm._v(" "),
                            _vm.certificateArr.length > 0
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary float-right mt-2",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.removeCertificate()
                                        }
                                      }
                                    },
                                    [_vm._v("-")]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-sm-4" },
                              [
                                _vm._l(_vm.certificateArr, function(i, index) {
                                  return [
                                    _c("input", {
                                      staticClass: "form-control form-group",
                                      attrs: {
                                        id: _vm.certificateModel.id[index],
                                        type: "text",
                                        placeholder: "Enter Certificate"
                                      },
                                      on: { input: _vm.setSelected }
                                    })
                                  ]
                                })
                              ],
                              2
                            )
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addBenifitBtn",
                    type: "submit",
                    value: "Update"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.updateTalentProfile()
                    }
                  }
                })
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
      [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01fb5cd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01fb5cd0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/talentprofile/TalentProfile.vue
// module id = null
// module chunks = 